import { Budget } from "./../../../models/attendance/budget";

import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, PageOptions } from "cw-backend";
import { CwUtils } from "cw-utils";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class BudgetListProvider implements Resolve<any> {
    budget: Budget[];
    budgetEdit: Budget;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(public gw: ApiGateway, private location: Location) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.budgetEdit = this.state?.currentBudget;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "dated";
            this.pageOptions.sortDirection = "desc";
        }
        return new Promise((resolve, reject) => {
            Promise.all([this.getPagev2(this.pageOptions, "O")]).then(() => {
                resolve(true);
            }, reject);
        });
    }

    get(id: number): Observable<any> {
        if (!id) {
            return null;
        }
        return this.gw.get("budget/:id", { id: id });
    }

    get currentBudget(): Budget {
        return this.budgetEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("budget/").subscribe({
                next: (res: HttpResponse<any>) => {
                    this.budget = res.body;
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPage(pageOptions: PageOptions, type: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("budget/search/" + type, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.budget, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.budget = res.body.content;
                        this.onDataChanged.next(this.budget);
                    } else {
                        this.budget = res.body.content;
                    }
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

     getPagev2(pageOptions: PageOptions, type: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("budget/v2/search/" + type, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.budget, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.budget = res.body.content;
                        this.onDataChanged.next(this.budget);
                    } else {
                        this.budget = res.body.content;
                    }
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }



    getPageProtocol(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("protocol/search/" + "P", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.budget, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.budget = res.body.content;
                        this.onDataChanged.next(this.budget);
                    } else {
                        this.budget = res.body.content;
                    }
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}
